import { render } from "./SBtable.vue?vue&type=template&id=047c6436&scoped=true"
import script from "./SBtable.vue?vue&type=script&lang=js"
export * from "./SBtable.vue?vue&type=script&lang=js"

import "./SBtable.vue?vue&type=style&index=0&id=047c6436&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047c6436"]])

export default __exports__